import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './containers/Home/Home';
import reportWebVitals from './reportWebVitals';
import DarkMode from './components/darkMode/DarkMode';

ReactDOM.render(
  <React.StrictMode>
    <DarkMode>
      <Home />
    </DarkMode>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
